import { render } from "./PetType.vue?vue&type=template&id=3cfe38fe"
import script from "./PetType.vue?vue&type=script&lang=js"
export * from "./PetType.vue?vue&type=script&lang=js"

import "./PetType.vue?vue&type=style&index=0&id=3cfe38fe&lang=css"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__